import { Card } from '@design-system';

import { ItemListStoryblok } from '../types/generated-storyblok';
import { ContentArtist } from './Journals/ContentArtist';
import { ContentInsight } from './Journals/ContentInsight';
import { ContentLocation } from './Journals/ContentLocation';
import { ContentProduct } from './Journals/ContentProduct';

interface ContentBlockItemListProps {
  blok: ItemListStoryblok;
}

export const ContentBlockItemList = ({ blok }: ContentBlockItemListProps) => (
  <Card className="mx-auto flex w-full max-w-lg flex-col divide-y px-4">
    {blok.items.map((item) => {
      switch (item.component) {
        case 'artistId':
          return <ContentArtist key={item._uid} blok={item} variant="list" />;
        case 'locationItem':
          return <ContentLocation key={item._uid} blok={item} />;
        case 'productId':
          return <ContentProduct key={item._uid} blok={item} />;
        case 'insightId':
          return <ContentInsight key={item._uid} blok={item} variant="list" />;
        default:
          return null;
      }
    })}
  </Card>
);
